import { createValidator, stringRequired, validate } from '.';
import { wait } from '../../utility';

/**
 * @returns {import('vue').Component}
 */
export const ValidatorMixin = () => {
  return {
    props: {
      min: {
        type: Number,
      },
      max: {
        type: Number,
      },
      required: {
        type: Boolean,
        default: false,
      },
      pattern: {
        type: String,
      },
      validators: {
        type: Array,
        default: () => [],
      },
      showValidationIcons: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      this.validateInput(this.value);
    },
    data() {
      return {
        validatorsMap: {},
        touched: false,
        validationResult: {
          valid: true,
          errors: [],
          errorMessages: []
        },
      }
    },
    watch: {
      required: {
        immediate: true,
        handler: function (newValue, oldValue) {
          if (newValue) {
            this.validatorsMap['required'] = createValidator({
              name: 'required',
              validatorFn: stringRequired,
              errorMessage: `${this.label} Can't be empty`
            });
          }
        }
      },
      validators: {
        immediate: true,
        handler: function (newValue, oldValue) {
          // console.log({ "Validators Input ID": this.id, newValue });
          (newValue || []).forEach(val => {
            this.validatorsMap[val.name] = val;
          });
        }
      },
      value: {
        immediate: true,
        handler: function (newVal, oldVal) {
          this.runDOMLogic();
          this.validateInput(newVal);
        },
      }
    },
    methods: {
      errorMessages: function () {
        return this.validationResult?.errorMessages.length > 0 ? this.validationResult.errorMessages.join(', ') : 'Error';
      },
      getValidatorArray: function () {
        return Object.keys(this.validatorsMap).map(key => {
          return {
            name: key,
            ...this.validatorsMap[key]
          };
        })
      },
      validateInput: async function (value, control) {
        // console.log({ "2 validators": this.validators, value });
        // if (this.validators?.length > 1) {
        //   console.log({ "2 validators": this.validators });
        // }
        // console.log({ "validateInput": 1 });

        this.validationResult = validate(this.getValidatorArray())(value);
        // console.log({ "this.validationResult": this.validationResult, "this.validators": this.validators });
        this.$emit('validated', this.id, this.validationResult);

        // If Control is Undefined - Then The Validate function is being called from mounted function
        if (!control) {
          control = this.$refs['fc-control'];
        }

        if (control) {
          // Normal Validate Input Function Call
          // If ValidationResult is false - Set the Validation Message
          if (!this.validationResult.valid) {
            control.setCustomValidity(this.validationResult?.errorMessages);
            control.reportValidity();
          } else {
            control.setCustomValidity('');
            control.reportValidity();
          }
        }


        return this.validationResult;
      },
    }
  }
}